<template>
  <main class="home-page">
  
<div class="page-header">
  <div class="header-left">
    <div class="breadcrumb-text">
      <i class="fa fa-th-large"></i> Workspace / Overview
    </div>
    <h1 class="page-title">CRO & Organization Dashboard</h1>
    <p class="page-desc">Operational view across all sponsors, CROs, sites and active study assignments.</p>
  </div>
  <div class="header-actions">
    <button class="btn-export">
      <i class="fa fa-download"></i> Export
    </button>
    <button class="btn-new" @click="openNewOrganization">
      <i class="fa fa-plus"></i> New Organization
    </button>
  </div>
</div>
    <div class="container-fluid px-4">
      <div class="row g-3">

        <!-- Organizations -->
        <div class="col-md-2">
          <div class="stat-card">
            <div class="stat-label">
              Organizations
              <span class="stat-icon icon-blue"><i class="fa fa-building"></i></span>
            </div>
            <div class="stat-number">486</div>
            <div class="stat-row">
              <div>
                <div class="sub-val">412</div>
                <div class="sub-label">Active</div>
              </div>
              <div class="divider-v"></div>
              <div>
                <div class="sub-val">18</div>
                <div class="sub-label">New this month</div>
              </div>
            </div>
            <div class="stat-footer">
              <span class="trend-up"><i class="fa fa-arrow-up"></i> 4.1%</span>
              <span class="meta">vs last month</span>
            </div>
          </div>
        </div>

        <!-- Contract Research Orgs -->
        <div class="col-md-2">
          <div class="stat-card">
            <div class="stat-label">
              Contract Research
              <span class="stat-icon icon-purple"><i class="fa fa-users"></i></span>
            </div>
            <div class="stat-number">128</div>
            <div class="stat-row">
              <div>
                <div class="sub-val">119</div>
                <div class="sub-label">Active CROs</div>
              </div>
              <div class="divider-v"></div>
              <div>
                <div class="sub-val text-dark" style="font-size: 13px;">Parexel</div>
                <div class="sub-label">Top performer</div>
              </div>
            </div>
            <div class="stat-footer">
              <span class="trend-up"><i class="fa fa-arrow-up"></i> 2.4%</span>
              <span class="meta">92.9% active rate</span>
            </div>
          </div>
        </div>

        <!-- Studies -->
        <div class="col-md-2">
          <div class="stat-card">
            <div class="stat-label">
              Studies
              <span class="stat-icon icon-gray"><i class="fa fa-file-text"></i></span>
            </div>
            <div class="stat-number">342</div>
            <div class="stat-row">
              <div>
                <div class="sub-val text-blue">198</div>
                <div class="sub-label">Active</div>
              </div>
              <div class="divider-v"></div>
              <div>
                <div class="sub-val text-amber">64</div>
                <div class="sub-label">In recruitment</div>
              </div>
            </div>
            <div class="stat-footer">
              <span class="trend-up"><i class="fa fa-arrow-up"></i> 6.8%</span>
              <span class="meta">22 in setup.</span>
            </div>
          </div>
        </div>

        <!-- Contracts -->
        <div class="col-md-2">
          <div class="stat-card">
            <div class="stat-label">
              Contracts
              <span class="stat-icon icon-green"><i class="fa fa-file"></i></span>
            </div>
            <div class="stat-number">214</div>
            <div class="stat-row">
              <div>
                <div class="sub-val text-green">189</div>
                <div class="sub-label">Active</div>
              </div>
              <div class="divider-v"></div>
              <div>
                <div class="sub-val text-amber">7</div>
                <div class="sub-label">Expiring soon</div>
              </div>
            </div>
            <div class="stat-footer">
              <span class="trend-down"><i class="fa fa-arrow-down"></i> 0.0%</span>
              <span class="meta">$412M total value</span>
            </div>
          </div>
        </div>

        <!-- Compliance -->
        <div class="col-md-2">
          <div class="stat-card">
            <div class="stat-label">
              Compliance
              <span class="stat-icon icon-amber"><i class="fa fa-shield"></i></span>
            </div>
            <div class="stat-number">12</div>
            <div class="stat-row">
              <div>
                <div class="sub-val text-red">3</div>
                <div class="sub-label">Critical alerts</div>
              </div>
              <div class="divider-v"></div>
              <div>
                <div class="sub-val text-amber">5</div>
                <div class="sub-label">Pending audits</div>
              </div>
            </div>
            <div class="stat-footer">
              <span class="trend-down"><i class="fa fa-arrow-down"></i> 2 new</span>
              <span class="meta">since last week</span>
            </div>
          </div>
        </div>

        <!-- Contracts -->
        <div class="col-md-2">
          <div class="stat-card">
            <div class="stat-label">
              Contracts
              <span class="stat-icon icon-green"><i class="fa fa-file"></i></span>
            </div>
            <div class="stat-number">214</div>
            <div class="stat-row">
              <div>
                <div class="sub-val text-green">189</div>
                <div class="sub-label">Active</div>
              </div>
              <div class="divider-v"></div>
              <div>
                <div class="sub-val text-amber">7</div>
                <div class="sub-label">Expiring soon</div>
              </div>
            </div>
            <div class="stat-footer">
              <span class="trend-down"><i class="fa fa-arrow-down"></i> 0.0%</span>
              <span class="meta">$412M total value</span>
            </div>
          </div>
        </div>

      </div>

      <!-- Compliance Alerts & Contract Management -->
      <div class="row g-3 mt-1">

        <!-- Compliance Alerts -->
        <div class="col-md-6">
          <div class="stat-card">
            <div class="section-header">
              <div>
                <div class="section-title">Compliance Alerts</div>
                <div class="section-sub">Open items requiring action</div>
              </div>
              <span class="stat-icon icon-red"><i class="fa fa-warning"></i></span>
            </div>

            <div class="alert-list">

              <div class="alert-item">
                <span class="alert-icon-wrap icon-red-soft"><i class="fas fa-clipboard-check"></i></span>
                <div class="alert-body">
                  <div class="alert-title">GCP Audit Due</div>
                  <div class="alert-meta">IQVIA · Study ONC-4471 · due in 6 days</div>
                </div>
                <span class="badge-critical">CRITICAL</span>
              </div>

              <div class="alert-item">
                <span class="alert-icon-wrap icon-blue-soft"><i class="fa fa-user-times"></i></span>
                <div class="alert-body">
                  <div class="alert-title">ISO Certification Expiring</div>
                  <div class="alert-meta">Medpace · ISO 9001 lapses in 21 days</div>
                </div>
                <span class="badge-high">HIGH</span>
              </div>

              <div class="alert-item">
                <span class="alert-icon-wrap icon-amber-soft"><i class="fa fa-shield"></i></span>
                <div class="alert-body">
                  <div class="alert-title">GDPR Compliance Issue</div>
                  <div class="alert-meta">Novotech · data transfer review pending</div>
                </div>
                <span class="badge-high">HIGH</span>
              </div>

              <div class="alert-item">
                <span class="alert-icon-wrap icon-yellow-soft"><i class="fas fa-file-medical"></i></span>
                <div class="alert-body">
                  <div class="alert-title">HIPAA Documentation Pending</div>
                  <div class="alert-meta">Fortrea · 3 site agreements unsigned</div>
                </div>
                <span class="badge-medium">MEDIUM</span>
              </div>

              <div class="alert-item">
                <span class="alert-icon-wrap icon-blue-soft"><i class="fas fa-file-signature"></i></span>
                <div class="alert-body">
                  <div class="alert-title">Periodic Safety Report</div>
                  <div class="alert-meta">PPD · PSUR submission within 14 days</div>
                </div>
                <span class="badge-low">LOW</span>
              </div>

            </div>
          </div>
        </div>

        <!-- Contract Management -->
        <div class="col-md-6">
          <div class="stat-card">
            <div class="section-header">
              <div>
                <div class="section-title">Contract Management</div>
                <div class="section-sub">Renewals and approvals pipeline</div>
              </div>
              <button class="btn-viewall">View all</button>
            </div>

            <div class="table-responsive-wrap">
              <table class="contract-table">
                <thead>
                  <tr>
                    <th>CONTRACT</th>
                    <th>ORGANIZATION</th>
                    <th>EXPIRY</th>
                    <th>STATUS</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td class="contract-id">MSA-2024-118</td>
                    <td><span class="org-badge bg-teal">IQ</span> IQVIA</td>
                    <td>12 Jul 2026</td>
                    <td><span class="status-pill pill-amber">● Expiring Soon</span></td>
                  </tr>
                  <tr>
                    <td class="contract-id">SOW-2025-431</td>
                    <td><span class="org-badge bg-purple">PX</span> Parexel</td>
                    <td>04 Mar 2027</td>
                    <td><span class="status-pill pill-green">● Active</span></td>
                  </tr>
                  <tr>
                    <td class="contract-id">CDA-2026-007</td>
                    <td><span class="org-badge bg-orange">MP</span> Medpace</td>
                    <td>28 Jul 2026</td>
                    <td><span class="status-pill pill-blue">● Pending Approval</span></td>
                  </tr>
                  <tr>
                    <td class="contract-id">MSA-2023-076</td>
                    <td><span class="org-badge bg-indigo">IC</span> ICON plc</td>
                    <td>15 Sep 2027</td>
                    <td><span class="status-pill pill-teal">● Renewed</span></td>
                  </tr>
                  <tr>
                    <td class="contract-id">SOW-2025-218</td>
                    <td><span class="org-badge bg-green">SY</span> Syneos Health</td>
                    <td>09 Aug 2026</td>
                    <td><span class="status-pill pill-amber">● Expiring Soon</span></td>
                  </tr>
                  <tr>
                    <td class="contract-id">MSA-2024-302</td>
                    <td><span class="org-badge bg-red">FT</span> Fortrea</td>
                    <td>22 Jan 2028</td>
                    <td><span class="status-pill pill-green">● Active</span></td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>

      </div>

      <!-- AI Insights + Recent Activity -->
      <div class="row g-3 mt-1">

        <!-- AI Insights -->
        <div class="col-md-6">
          <div class="ai-insights-card">
            <div class="ai-header">
              <div class="ai-title-wrap">
                <div class="ai-icon-wrap">
                  <i class="fa-solid fa-sun"></i>
                </div>
                <div>
                  <div class="ai-title">AI Insights</div>
                  <div class="ai-sub">Predictive intelligence across your CRO network</div>
                </div>
              </div>
              <span class="live-badge"><span class="live-dot"></span> Live model</span>
            </div>

            <div class="ai-grid">
              <div class="ai-item">
                <div class="ai-item-label"><i class="fa fa-bar-chart"></i> Best Performing CRO</div>
                <div class="ai-item-body"><strong>Parexel</strong> leads with a 96.2 composite — 4.3 pts above network median, driven by fastest site.</div>
                <div class="ai-conf-row">
                  <span class="conf-label">Confidence</span>
                  <div class="conf-bar-wrap"><div class="conf-bar" style="width:94%"></div></div>
                  <span class="conf-val">94%</span>
                </div>
                <a class="ai-item-action">View profile →</a>
              </div>

              <div class="ai-item">
                <div class="ai-item-label"><i class="fa fa-warning"></i> CRO Risk Scores</div>
                <div class="ai-item-body"><strong>Medivance Labs</strong> flagged <span class="badge-high-risk">High</span> — recruitment 31% below plan on 3 oncology studies.</div>
                <div class="ai-conf-row">
                  <span class="conf-label">Confidence</span>
                  <div class="conf-bar-wrap"><div class="conf-bar" style="width:88%"></div></div>
                  <span class="conf-val">88%</span>
                </div>
                <a class="ai-item-action">Open risk review →</a>
              </div>

              <div class="ai-item">
                <div class="ai-item-label"><i class="fa fa-line-chart"></i> Recruitment Forecast</div>
                <div class="ai-item-body">Network enrollment projected to hit <strong>104% of target</strong> by Q3 — APAC sites outpacing plan by patients.</div>
                <div class="ai-conf-row">
                  <span class="conf-label">Confidence</span>
                  <div class="conf-bar-wrap"><div class="conf-bar conf-bar-purple" style="width:79%"></div></div>
                  <span class="conf-val">79%</span>
                </div>
                <a class="ai-item-action">See forecast →</a>
              </div>

              <div class="ai-item">
                <div class="ai-item-label"><i class="fa fa-file-text-o"></i> Renewal Recommendations</div>
                <div class="ai-item-body"><strong>7 contracts</strong> expiring within 60 days. AI recommends early renewal for 4 high-performers; <span class="badge-action-label">Action</span></div>
                <div class="ai-conf-row">
                  <span class="conf-label">Confidence</span>
                  <div class="conf-bar-wrap"><div class="conf-bar" style="width:91%"></div></div>
                  <span class="conf-val">91%</span>
                </div>
                <a class="ai-item-action">Review renewals →</a>
              </div>
            </div>
          </div>
        </div>

        <!-- Recent Activity -->
        <div class="col-md-6">
          <div class="stat-card">
            <div class="section-header">
              <div>
                <div class="section-title">Recent Activity</div>
                <div class="section-sub">Across organizations &amp; studies</div>
              </div>
            </div>
            <div class="activity-list">
              <div class="activity-item" v-for="item in recentActivity" :key="item.id">
                <div class="av" :class="item.avatarClass">{{ item.initials }}</div>
                <div class="activity-body">
                  <div class="activity-text" v-html="item.text"></div>
                  <div class="activity-meta-row">
                    <span class="tag" :class="item.tagClass">{{ item.tag }}</span>
                    <span class="tag tag-person">{{ item.person }}</span>
                    <span class="activity-time">{{ item.time }}</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

      </div>

         <!-- Charts Section with ApexCharts -->
      <div class="row g-3 mt-1">
        <!-- Studies by Phase -->
        <div class="col-md-6">
          <div class="stat-card">
            <div class="chart-header">
              <div>
                <div class="section-title">Studies by Phase</div>
                <div class="section-sub">342 studies in the active portfolio</div>
              </div>
            </div>
            <div id="studiesByPhaseChart"></div>
          </div>
        </div>

        <!-- Studies by Therapeutic Area - Progress Bars -->
        <div class="col-md-6">
          <div class="stat-card">
            <div class="chart-header">
              <div>
                <div class="section-title">Studies by Therapeutic Area</div>
                <div class="section-sub">Distribution across indications</div>
              </div>
            </div>
            <div class="therapeutic-area-bars">
              <div class="therapeutic-bar-item" v-for="(area, index) in therapeuticAreas" :key="index">
                <div class="bar-label-row">
                  <div class="bar-label">{{ area.name }}</div>
                  <div class="bar-value">{{ area.percentage }}%</div>
                </div>
                <div class="bar-container">
                  <div class="bar-fill" :style="{ width: area.percentage + '%', backgroundColor: area.color }"></div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <OrganizationModal ref="orgModal" />
  </main>
</template>

<script src="./home.js"></script>

<style scoped>
.home-page {
  min-height: calc(100vh - 56px);
  background: #f5f7fb;
  color: #1f2937;
  -webkit-user-drag: none;
  -webkit-touch-callout: none;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
  overflow-x: hidden;
}

/* Header */
.page-header {
  padding: 16px 24px 12px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  flex-wrap: wrap;
}
.header-left {
  min-width: 0;
}
.breadcrumb-text {
  font-size: 12px;
  color: #6b7280;
  margin-bottom: 2px;
  font-weight: 400;
}
.page-title {
  font-size: 20px;
  font-weight: 700;
  color: #111827;
  margin: 0;
}
.page-desc {
  font-size: 13px;
  color: #6b7280;
  margin: 2px 0 0;
}
.header-actions {
  display: flex;
  gap: 10px;
  align-items: center;
  flex-wrap: wrap;
}
.btn-export {
  background: #fff;
  border: 1px solid #d1d5db;
  color: #374151;
  font-size: 13px;
  padding: 7px 14px;
  border-radius: 8px;
  cursor: pointer;
  font-weight: 500;
  white-space: nowrap;
}
.btn-new {
  background: #2ed8c7;
  border: none;
  color: #fff;
  font-size: 13px;
  padding: 7px 14px;
  border-radius: 8px;
  cursor: pointer;
  font-weight: 500;
  white-space: nowrap;
}

/* Container */
.container-fluid.px-4 {
  padding-left: 24px;
  padding-right: 24px;
  max-width: 100%;
}

/* Stat Cards */
.stat-card {
  background: #fff;
  border-radius: 10px;
  border: 1px solid #e5e7eb;
  padding: 12px 14px;
  height: 100%;
}
.stat-label {
  font-size: 12px;
  color: #6b7280;
  font-weight: 500;
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 6px;
  gap: 8px;
}
.stat-icon {
  width: 28px;
  height: 28px;
  border-radius: 7px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 13px;
  flex-shrink: 0;
}
.icon-blue   { background: #eff6ff; color: #2563eb; }
.icon-purple { background: #f5f3ff; color: #7c3aed; }
.icon-gray   { background: #f3f4f6; color: #6b7280; }
.icon-green  { background: #f0fdf4; color: #16a34a; }
.icon-amber  { background: #fffbeb; color: #d97706; }

.stat-number {
  font-size: 24px;
  font-weight: 700;
  color: #111827;
  line-height: 1.1;
  margin-bottom: 8px;
}

/* Sub-row */
.stat-row {
  display: flex;
  align-items: flex-start;
  gap: 10px;
}
.sub-val {
  font-size: 13px;
  font-weight: 700;
  color: #111827;
  line-height: 1.2;
  word-break: break-word;
}
.sub-label {
  font-size: 10px;
  color: #9ca3af;
  margin-top: 1px;
}
.divider-v {
  width: 1px;
  height: 34px;
  background: #e5e7eb;
  align-self: center;
  flex-shrink: 0;
}

/* Color overrides */
.text-blue  { color: #2563eb !important; }
.text-green { color: #16a34a !important; }
.text-amber { color: #d97706 !important; }
.text-red   { color: #dc2626 !important; }
.text-dark  { color: #1f2937 !important; }

/* Footer trends */
.stat-footer {
  margin-top: 8px;
  display: flex;
  align-items: center;
  gap: 6px;
  flex-wrap: wrap;
}
.trend-up {
  font-size: 11px;
  color: #16a34a;
  background: #f0fdf4;
  padding: 2px 6px;
  border-radius: 4px;
  font-weight: 600;
}
.trend-down {
  font-size: 11px;
  color: #dc2626;
  background: #fef2f2;
  padding: 2px 6px;
  border-radius: 4px;
  font-weight: 600;
}
.meta {
  font-size: 10px;
  color: #9ca3af;
}

/* Chart styling */
.chart-header {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  margin-bottom: 16px;
  gap: 8px;
  flex-wrap: wrap;
}

#studiesByPhaseChart {
  max-width: 100%;
  overflow: hidden;
}

/* Therapeutic Area Progress Bars */
.therapeutic-area-bars {
  display: flex;
  flex-direction: column;
  gap: 14px;
}

.therapeutic-bar-item {
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.bar-label-row {
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 8px;
}

.bar-label {
  font-size: 13px;
  color: #374151;
  font-weight: 500;
}

.bar-container {
  width: 100%;
  height: 8px;
  background: #f3f4f6;
  border-radius: 4px;
  overflow: hidden;
}

.bar-fill {
  height: 100%;
  border-radius: 4px;
  transition: width 0.3s ease;
}

.bar-value {
  font-size: 13px;
  color: #1f2937;
  font-weight: 600;
  flex-shrink: 0;
}

/* Section headers */
.section-header {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  margin-bottom: 14px;
  gap: 8px;
  flex-wrap: wrap;
}
.section-title {
  font-size: 14px;
  font-weight: 700;
  color: #111827;
}
.section-sub {
  font-size: 11px;
  color: #9ca3af;
  margin-top: 2px;
}
.icon-red { background: #fef2f2; color: #dc2626; }

/* Alert list */
.alert-list {
  display: flex;
  flex-direction: column;
  gap: 10px;
}
.alert-item {
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 8px 12px;
  border-radius: 8px;
  background: #f9fafb;
  border: 1px solid #f3f4f6;
  flex-wrap: wrap;
}
.alert-icon-wrap {
  width: 32px;
  height: 32px;
  border-radius: 8px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 14px;
  flex-shrink: 0;
}
.icon-red-soft    { background: #fef2f2; color: #dc2626; }
.icon-amber-soft  { background: #fffbeb; color: #175306; }
.icon-yellow-soft { background: #fefce8; color: #ca8a04; }
.icon-blue-soft   { background: #eff6ff; color: #2563eb; }

.alert-body {
  flex: 1;
  min-width: 140px;
}
.alert-title {
  font-size: 13px;
  font-weight: 600;
  color: #111827;
  user-select: text;
  -webkit-user-select: text;
}
.alert-meta {
  font-size: 11px;
  color: #9ca3af;
  margin-top: 1px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  user-select: text;
 -webkit-user-select: text;
}

/* Badges */
.badge-critical {
  font-size: 10px;
  font-weight: 700;
  padding: 3px 8px;
  border-radius: 4px;
  background: #fef2f2;
  color: #dc2626;
  white-space: nowrap;
  flex-shrink: 0;
}
.badge-high {
  font-size: 10px;
  font-weight: 700;
  padding: 3px 8px;
  border-radius: 4px;
  background: #fffbeb;
  color: #d97706;
  white-space: nowrap;
  flex-shrink: 0;
}
.badge-medium {
  font-size: 10px;
  font-weight: 700;
  padding: 3px 8px;
  border-radius: 4px;
  background: #fefce8;
  color: #ca8a04;
  white-space: nowrap;
  flex-shrink: 0;
}
.badge-low {
  font-size: 10px;
  font-weight: 700;
  padding: 3px 8px;
  border-radius: 4px;
  background: #eff6ff;
  color: #2563eb;
  white-space: nowrap;
  flex-shrink: 0;
}

/* Contract table */
.btn-viewall {
  font-size: 11px;
  font-weight: 500;
  color: #374151;
  background: #fff;
  border: 1px solid #d1d5db;
  padding: 5px 10px;
  border-radius: 7px;
  cursor: pointer;
  white-space: nowrap;
}
.table-responsive-wrap {
  width: 100%;
  overflow-x: auto;
  -webkit-overflow-scrolling: touch;
}
.contract-table {
  width: 100%;
  min-width: 480px;
  border-collapse: collapse;
  font-size: 13px;
}
.contract-table thead th {
  font-size: 10px;
  font-weight: 600;
  color: #9ca3af;
  text-transform: uppercase;
  letter-spacing: 0.5px;
  padding: 0 10px 8px 0;
  border-bottom: 1px solid #f3f4f6;
  white-space: nowrap;
}
.contract-table tbody tr {
  border-bottom: 1px solid #f9fafb;
}
.contract-table tbody tr:last-child {
  border-bottom: none;
}
.contract-table tbody td {
  padding:5px 5px 5px 0;
  color: #374151;
  vertical-align: middle;
  white-space: nowrap;
}
.contract-id {
  font-weight: 600;
  color: #111827 !important;
  font-size: 12px;
}

/* Org avatar badges */
.org-badge {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 26px;
  height: 26px;
  border-radius: 6px;
  font-size: 10px;
  font-weight: 700;
  color: #fff;
  margin-right: 6px;
  vertical-align: middle;
}
.bg-teal   { background: #0cb8a8; }
.bg-purple { background: #7c3aed; }
.bg-orange { background: #ea580c; }
.bg-indigo { background: #4f46e5; }
.bg-green  { background: #16a34a; }
.bg-red    { background: #dc2626; }

/* Status pills */
.status-pill {
  font-size: 11px;
  font-weight: 600;
  padding: 3px 10px;
  border-radius: 20px;
  white-space: nowrap;
}
.pill-amber { background: #fffbeb; color: #d97706; }
.pill-green { background: #f0fdf4; color: #16a34a; }
.pill-blue  { background: #eff6ff; color: #2563eb; }
.pill-teal  { background: #f0fdfa; color: #0cb8a8; }

/* AI Insights card */
.ai-insights-card {
  background: #141c2e;
  border-radius: 10px;
  padding: 16px;
  height: 100%;
}
.ai-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 14px;
  gap: 8px;
  flex-wrap: wrap;
}
.ai-title-wrap { display: flex; align-items: center; gap: 10px; }
.ai-icon-wrap {
  width: 34px; height: 34px; border-radius: 8px;
  background: #1e2d4a; display: flex; align-items: center;
  justify-content: center; color: #ffe417; font-size: 16px;
  flex-shrink: 0;
}
.ai-title { font-size: 15px; font-weight: 700; color: #f0f4ff; }
.ai-sub { font-size: 11px; color: #6b7fa0; margin-top: 1px; }
.live-badge {
  display: flex; align-items: center; gap: 6px;
  background: #1a2d1a; border: 1px solid #2a4a2a;
  border-radius: 20px; padding: 4px 10px;
  font-size: 11px; font-weight: 600; color: #4ade80;
  white-space: nowrap;
}
.live-dot { width: 6px; height: 6px; border-radius: 50%; background: #4ade80; flex-shrink: 0; }
.ai-grid { display: grid; grid-template-columns: 1fr 1fr; gap: 10px; }
.ai-item {
  background: #1a2440; border: 1px solid #243050;
  border-radius: 8px; padding: 12px;
  min-width: 0;
}
.ai-item-label {
  font-size: 10px; font-weight: 600; color: #6b7fa0;
  text-transform: uppercase; letter-spacing: 0.5px;
  margin-bottom: 8px;
}
.ai-item-label i { margin-right: 4px; }
.ai-item-body { font-size: 11.5px; color: #c8d4f0; line-height: 1.5; margin-bottom: 10px; word-break: break-word; }
.ai-item-body strong { color: #f0f4ff; }
.ai-conf-row { display: flex; align-items: center; }
.conf-label { font-size: 10px; color: #6b7fa0; flex-shrink: 0; }
.conf-bar-wrap { flex: 1; margin: 0 8px; background: #243050; border-radius: 4px; height: 4px; min-width: 20px; }
.conf-bar { height: 4px; border-radius: 4px; background: #2ed8c7; }
.conf-bar-purple { background: #818cf8; }
.conf-val { font-size: 10px; color: #8fa0c0; flex-shrink: 0; }
.ai-item-action { display: block; margin-top: 8px; font-size: 11px; color: #2ed8c7; font-weight: 500; cursor: pointer; text-decoration: none; }
.badge-high-risk {
  display: inline-flex; align-items: center;
  background: #3a1a1a; border: 1px solid #5a2a2a;
  border-radius: 4px; padding: 1px 6px;
  font-size: 10px; font-weight: 700; color: #f87171;
}
.badge-action-label {
  display: inline-block; background: #3a2a0a; border: 1px solid #5a4a0a;
  border-radius: 4px; padding: 2px 8px;
  font-size: 10px; font-weight: 700; color: #fbbf24; margin-top: 4px;
}

/* Activity feed */
.activity-list { display: flex; flex-direction: column; }
.activity-item {
  display: flex; align-items: flex-start; gap: 10px;
  padding: 10px 0; border-bottom: 1px solid #f3f4f6;
}
.activity-item:last-child { border-bottom: none; }
.av {
  width: 32px; height: 32px; border-radius: 50%;
  display: flex; align-items: center; justify-content: center;
  font-size: 11px; font-weight: 700; color: #fff; flex-shrink: 0;
}
.activity-body { flex: 1; min-width: 0; }
.activity-text { 
  font-size: 13px; 
  color: #374151; 
  line-height: 1.4;
  word-break: break-word;
}
.activity-text strong { color: #111827; font-weight: 600; }
.activity-meta-row { display: flex; align-items: center; gap: 6px; margin-top: 3px; flex-wrap: wrap; }
.tag { font-size: 10px; font-weight: 600; padding: 2px 7px; border-radius: 4px; }
.tag-person { background: #f3f4f6; color: #6b7280; }
.activity-time { font-size: 10px; color: #9ca3af; }

/* Avatar colors */
.av-purple { background: #7c3aed; }
.av-teal   { background: #0cb8a8; }
.av-dark   { background: #374151; }
.av-green  { background: #16a34a; }
.av-icon::after { content: '\f013'; font-family: 'FontAwesome'; font-size: 14px; }

/* Tag type colors */
.tag-cro        { background: #eff6ff; color: #2563eb; }
.tag-study      { background: #f0fdf4; color: #16a34a; }
.tag-contract   { background: #f5f3ff; color: #7c3aed; }
.tag-compliance { background: #fef3c7; color: #d97706; }
.tag-sponsor    { background: #fce7f3; color: #db2777; }

/* Activity timeline connector */
.activity-item { 
  position: relative;
}
.activity-item::before {
  content: '';
  position: absolute;
  left: 15px;
  top: 42px;
  bottom: -2px;
  width: 2px;
  background: #e5e7eb;
  pointer-events: none;
  user-select: none;
}
.activity-item:last-child::before { display: none; }

/* ============================================= */
/* RESPONSIVE OVERRIDES                           */
/* ============================================= */

/* Tablets / small laptops: 6 stat cards -> 3 per row */
@media (max-width: 991.98px) {
  .col-md-2 {
    flex: 0 0 33.3333%;
    max-width: 33.3333%;
  }
  .container-fluid.px-4 {
    padding-left: 18px;
    padding-right: 18px;
  }
}

/* Large phones / small tablets */
@media (max-width: 767.98px) {
  .page-header {
    padding: 14px 16px 10px;
    flex-direction: column;
    align-items: flex-start;
  }
  .header-actions {
    width: 100%;
  }
  .btn-export,
  .btn-new {
    flex: 1 1 auto;
    text-align: center;
  }
  .page-title {
    font-size: 18px;
  }
  .page-desc {
    font-size: 12.5px;
  }

  .container-fluid.px-4 {
    padding-left: 12px;
    padding-right: 12px;
  }

  /* Stat cards: 2 per row */
  .col-md-2 {
    flex: 0 0 50%;
    max-width: 50%;
  }
  .stat-card {
    padding: 10px 12px;
  }
  .stat-number {
    font-size: 20px;
  }

  /* Everything that was half/full width on desktop stacks fully */
  .col-md-6 {
    flex: 0 0 100%;
    max-width: 100%;
  }

  /* AI insights grid collapses to a single column */
  .ai-grid {
    grid-template-columns: 1fr;
  }

  .section-title {
    font-size: 13.5px;
  }

  .alert-item {
    padding: 8px 10px;
  }

  .divider-v {
    height: 30px;
  }
}

/* Small phones */
@media (max-width: 480px) {
  .page-title {
    font-size: 16px;
  }
  .breadcrumb-text {
    font-size: 11px;
  }

  /* Stat cards: 1 per row */
  .col-md-2 {
    flex: 0 0 100%;
    max-width: 100%;
  }

  .stat-number {
    font-size: 22px;
  }

  .header-actions {
    flex-direction: column;
    align-items: stretch;
  }

  .ai-insights-card {
    padding: 12px;
  }
  .ai-item {
    padding: 10px;
  }
  .ai-title {
    font-size: 14px;
  }

  .alert-body {
    min-width: 100%;
    order: 3;
  }
  .alert-item {
    align-items: flex-start;
  }

  .contract-table {
    min-width: 420px;
  }
}
</style>